import { render, staticRenderFns } from "./WidgetBookingSize.vue?vue&type=template&id=9577ec6a&scoped=true"
import script from "./WidgetBookingSize.vue?vue&type=script&lang=js"
export * from "./WidgetBookingSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9577ec6a",
  null
  
)

export default component.exports